import { filter, takeUntil } from "rxjs/operators";
import { isActionOf } from "typesafe-actions";
import { ServerResponseStatus } from "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "rxjs";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { switchMap, mergeMap, map } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import { actions } from "./action.js";
class AsyncActionRequestEpicCreator {
  createRequestEpic(asyncAction, callback, shouldCancelPreviousAction = true) {
    return this.createActionEpic(asyncAction, callback, shouldCancelPreviousAction);
  }
  createActionEpic(asyncAction, callback, shouldCancelPreviousAction) {
    const mapRequest = shouldCancelPreviousAction ? switchMap : mergeMap;
    return (action$, state$) => {
      let actionId = null;
      let hasActionIdMeta = false;
      return action$.pipe(
        filter(isActionOf(asyncAction.request)),
        mapRequest((action) => {
          hasActionIdMeta = action?.meta?.actionId !== void 0;
          if (hasActionIdMeta) {
            actionId = action.meta?.actionId;
          }
          return callback(action.payload, state$?.value).pipe(
            takeUntil(
              action$.pipe(
                filter(isActionOf(actions.cancelRequests)),
                filter(() => action?.meta?.isCancelable !== false)
              )
            )
          );
        }),
        filter((res) => res !== null),
        map((response) => {
          let result;
          if (response.status === ServerResponseStatus.Success) {
            result = hasActionIdMeta ? asyncAction.success(response, { actionId }) : asyncAction.success(response);
          } else {
            const acrError = response?.errors?.find((error) => error.code === "ACR_INVALID");
            if (acrError) {
              const expectedAcr = acrError?.data?.expectedAcr;
              result = actions.redirectStepUp({ expectedAcr });
            } else {
              result = hasActionIdMeta ? asyncAction.failure(response, { actionId }) : asyncAction.failure(response);
            }
          }
          return result;
        })
      );
    };
  }
}
export {
  AsyncActionRequestEpicCreator
};
//# sourceMappingURL=asyncActionRequestEpicCreator.js.map
